import styled from "styled-components";
import { Card } from "@ann/web-components";

export const StyledCard = styled(Card)`
  min-height: 72px;
  padding: 12px 16px !important;
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: row;  
`

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;  
  flex: 1 1 auto;  
`

export const CheckBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  justify-content: center;
  align-content: center;  
`